import { useEffect, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { api } from 'common';

const emptyBucket = {
  items: [],
  hasMore: false,
  lastKey: null,
  loading: false,
  error: null,
};

export function useUsersPage(usertype, options = {}) {
  const {
    fleetadminUid = null,
    filterUsertype = null,
    enabled = true,
    limit,
  } = options;

  const dispatch = useDispatch();
  const { fetchUsersPage, resetUsersPage, getUsersPageKey } = api;

  const pageKey = useMemo(
    () => getUsersPageKey(usertype, fleetadminUid),
    [getUsersPageKey, usertype, fleetadminUid]
  );

  const bucket = useSelector(
    (state) => state.usersdata.usersPage?.[pageKey] || emptyBucket
  );

  const refresh = useCallback(() => {
    dispatch(resetUsersPage(pageKey));
    dispatch(
      fetchUsersPage({
        usertype,
        append: false,
        fleetadminUid,
        filterUsertype,
        limit,
      })
    );
  }, [
    dispatch,
    fetchUsersPage,
    resetUsersPage,
    pageKey,
    usertype,
    fleetadminUid,
    filterUsertype,
    limit,
  ]);

  useEffect(() => {
    if (!enabled) return;
    refresh();
  }, [enabled, refresh]);

  const loadMore = useCallback(() => {
    if (!bucket.hasMore || bucket.loading) return;
    dispatch(
      fetchUsersPage({
        usertype,
        append: true,
        startAfterKey: bucket.lastKey,
        fleetadminUid,
        filterUsertype,
        limit,
      })
    );
  }, [
    dispatch,
    fetchUsersPage,
    usertype,
    fleetadminUid,
    filterUsertype,
    limit,
    bucket.hasMore,
    bucket.loading,
    bucket.lastKey,
  ]);

  return {
    items: bucket.items,
    hasMore: bucket.hasMore,
    loading: bucket.loading,
    error: bucket.error,
    loadMore,
    refresh,
    pageKey,
  };
}
